// ─────────────────────────────────────────────────────────────────────
// Round MAFIA-Country-1 — MAFIA Aux working-database (country) pin.
//
// Legacy Mafia Auxiliary resolved a CountryCode global once at startup
// (domain/IP detection) and every Pluto call for the session used it —
// with NO manual switch. The modern requirement keeps the auto-detected
// default (the profile country claim, server-side) and ADDS a manual
// switch: the hero badge on the MAFIA Aux menu becomes a USA/India
// selector, and this module pins the selection as the X-Mafia-Country
// header on every api/mafia and api/vantage request.
//
// Server-side (MafiaCountryHelper) the value is VALIDATED — only
// "USA"/"INDIA" are honored, mapped to fixed configuration keys
// (PlutoConnection / PlutoConnectionIndia); the header can never name a
// connection string or company code. No pin (or an invalid one) simply
// falls back to the caller's profile-country default.
//
// The pin persists in sessionStorage so a page refresh inside the
// module keeps the chosen database for THIS browser tab; a new tab or
// login starts back at the auto-detected default. Same pattern as the
// Digital Inspection pin (src/pages/DI/diCountry.js), kept separate so
// the two modules can never cross-contaminate each other's selection.
// ─────────────────────────────────────────────────────────────────────
import api from "../../api";

export const MAFIA_COUNTRY_HEADER = "X-Mafia-Country";
const STORAGE_KEY = "mafiaAux.workingCountry";

function normalize(country) {
  const c = String(country || "").trim().toUpperCase();
  return c === "USA" || c === "INDIA" ? c : "";
}

let activeMafiaCountry = (() => {
  try {
    return normalize(sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return "";
  }
})();

/** Pin the MAFIA Aux working database ("USA" / "INDIA"; "" clears). */
export function setMafiaCountry(country) {
  activeMafiaCountry = normalize(country);
  try {
    if (activeMafiaCountry) {
      sessionStorage.setItem(STORAGE_KEY, activeMafiaCountry);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* storage unavailable — in-memory pin still works */
  }
}

export function getMafiaCountry() {
  return activeMafiaCountry;
}

export function clearMafiaCountry() {
  setMafiaCountry("");
}

/** Human label for UI ("USA Database" / "India Database"). */
export function mafiaCountryLabel(country) {
  return normalize(country) === "INDIA" ? "India Database" : "USA Database";
}

// api/mafia + api/vantage only — no other module's requests are touched
// (both leading-slash and bare relative forms appear in the Mafia pages).
const MAFIA_URL_RE = /^\/?(mafia|vantage)\b/i;

let interceptorRegistered = false;
function registerInterceptor() {
  if (interceptorRegistered) return;
  interceptorRegistered = true;
  api.interceptors.request.use((config) => {
    try {
      if (activeMafiaCountry && MAFIA_URL_RE.test(String(config?.url || ""))) {
        config.headers = config.headers || {};
        if (typeof config.headers.set === "function") {
          config.headers.set(MAFIA_COUNTRY_HEADER, activeMafiaCountry);
        } else {
          config.headers[MAFIA_COUNTRY_HEADER] = activeMafiaCountry;
        }
      }
    } catch {
      /* never break a request over the pin */
    }
    return config;
  });
}
registerInterceptor();
